import React from "react";
import { Route, Switch } from "react-router-dom";
import { INSTANT_DEALS_WON, INSTANT_DEALS_WON_DETAIL, } from "@Shared/Paths/Admin";
import DealDetail from "./DealDetail";
import List from "./List";
export default () => (React.createElement(Switch, null,
    React.createElement(Route, { path: INSTANT_DEALS_WON_DETAIL },
        React.createElement(DealDetail, null)),
    React.createElement(Route, { path: INSTANT_DEALS_WON, exact: true },
        React.createElement(List, null))));
